import {
  Component,
  OnInit,
  ElementRef,
  HostListener,
  OnDestroy
} from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { Home } from "../../interfaces/page";
import { HomeIntroService } from "../../services/home-intro.service";
import { MetaDataService } from "../../services/metadata.service";
import { map } from "rxjs/operators";
import * as $ from "jquery";
import { EventsService } from "../../services/events.service";

@Component({
  selector: "app-page-home",
  templateUrl: "./page-home.component.html",
  styleUrls: ["./page-home.component.scss"]
})
export class PageHomeComponent implements OnInit, OnDestroy {
  page$;
  content: Home;
  displayIntroduction: boolean;
  transitionIntroductionOut: boolean;
  desktop: boolean;
  $body;
  $window;
  _skrollr;
  routerSubscribe;
  activePageSlug: string;
  hideContent = true;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private events: EventsService,
    private his: HomeIntroService,
    private mds: MetaDataService,
    public el: ElementRef
  ) {
    // hide page content before intro is hidden
    this.$body = $("body");
    this.$body.addClass("home-intro-display");

    // Determine if we should display intro overlay
    this.displayIntroduction = this.his.displayHomeIntro();

    if (!this.displayIntroduction) {
      this.$body.removeClass("home-intro-display");
      this.hideContent = false;
    }

    this.events.on("route:change", ({ path, intro }) => {
      // Determine active page, and reset metadata to match
      this.activePageSlug = path;
      this.determineMetaData();
    });

    this.routerSubscribe = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // set active page slug so that metadata can be set properly after api request is finished
        this.activePageSlug = event.urlAfterRedirects.replace("/", "");
      }
    });
  }

  determineMetaData() {
    let useDefaultMetaData = true;
    if (
      this.activePageSlug &&
      this.content.sections &&
      this.content.sections.length
    ) {
      // see if page slug has a section metadata override
      const metaSection = this.content.sections.find(
        section => section.section_slug === this.activePageSlug
      );
      if (metaSection) {
        useDefaultMetaData = false;
        this.mds.setMetaData(metaSection);
      }
    }

    if (useDefaultMetaData) {
      // use default page metadata for "/" homepage
      this.mds.setMetaData(this.content);
    }
  }

  @HostListener("window:resize", ["$event"])
  onResize() {
    this.desktop = window.innerWidth > 767;
  }

  closeHomeIntro() {
    this.transitionIntroductionOut = true;
    this.$body.removeClass("home-intro-display");
    this.hideContent = false;
  }

  ngOnInit() {
    // Get page content
    this.onResize();
    this.page$ = this.route.data.pipe(map(r => r.content));
    this.page$.subscribe(page => {
      this.content = page;
      // set metadata
      this.determineMetaData();
    });
  }

  ngOnDestroy() {
    if (this.routerSubscribe) {
      this.routerSubscribe.unsubscribe();
    }
  }
}
